<template>
  <div class="dossier-footer">
    <div v-if="$slots.list" class="dossier-footer__list">
      <slot name="list"></slot>
    </div>
    <div v-if="$slots.title" class="dossier-footer__title">
      <slot name="title"></slot>
    </div>
    <div v-if="localThemeListData.length" class="dossier-footer__themes">
      <a
        v-for="(theme, i) in localThemeListData"
        :key="i"
        :href="theme.url"
        :class="[theme.active ? 'dossier-footer--active-theme' : '']"
        data-track-as="dossier"
      >
        {{ theme.themeName }}
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SanitasMagazineDossierFooter',
  props: {
    themeListData: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      localThemeListData: [],
    }
  },
  mounted() {
    if (this.themeListData) {
      this.localThemeListData = JSON.parse(this.themeListData)
    }
  },
}
</script>

<style lang="postcss">
.dossier-footer {
  max-width: 1100px;
  width: 100%;
  margin: var(--spacing-6) auto var(--spacing-16);

  sup {
    top: -0.2em !important;
  }
}

.dossier-footer__title {
  font-size: 18px;
  font-weight: bold;
  color: var(--c-primary-neutral-1);
}

dossier-footer__list {
  .title {
    font-family: 'Open Sans', sans-serif;
    padding-bottom: var(--spacing-4);
    margin-bottom: 0;
    font-size: 20px;
    font-weight: bold;
    color: var(--c-primary-neutral-1);
  }
}

.dossier-footer__themes {
  width: 100%;
  padding: var(--spacing-2) 0 0;

  a {
    font-size: 15px;
    font-weight: 400;
    color: var(--c-primary-neutral-1);
    margin-right: 15px;
    line-height: 20px;
    display: inline-block;

    &:hover {
      color: var(--c-primary-color-3);
      border-bottom: none;
    }
  }
}

.dossier-footer--active-theme {
  font-weight: bold;
  color: var(--c-primary-color-2);
}

.magazine-overview,
.magazine-article {
  .content-area .dossier-footer {
    padding: 0;
  }
}

@media (max-width: 1160px) {
  .dossier-footer {
    margin-right: 0;
    margin-left: 0;
    padding: 0 30px;
    max-width: initial;
  }
}

@media (max-width: 860px) {
  .dossier-footer {
    margin: 0 auto var(--spacing-8);
    padding: 0 var(--spacing-2);
  }
}

@media (max-width: 490px) {
  .dossier-footer__themes {
    padding-top: 15px;
  }
}
</style>
